<template>
  <div class="row justify-content-center">
    <div class="col-lg-6 mt-2">
      <b-tabs>
        <b-tab
          :title="`${this.$t('menu.settings.accountData.titleListTagsGroup')}`"
          active
        >
          <idx-card
            :title="`${this.$t(
              'menu.settings.accountData.titleListTagsGroup',
            )}`"
          >
            <div class="row">
              <div class="col-6">
                <div class="input-area">
                  <input
                    type="text"
                    class="form-control"
                    id="new-tags-group"
                    :placeholder="`${this.$t(
                      'menu.settings.accountData.placeholderNewGroupTag',
                    )}`"
                  />
                  <button class="btn btn-primary" @click="addTagsGroup">
                    <font-awesome-icon :icon="['fas', 'plus']" />
                  </button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 mt-4">
                <b-table striped :items="tagsGroups" :fields="groupFields">
                  <template v-slot:cell(active)="row">
                    <div class="custom-switch">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        :id="`is-active-tagsGroups-${row.item._id}`"
                        v-model="row.item.active"
                        @change="disableTagGroup(row.item._id, row.item.active)"
                      />
                      <label
                        class="custom-control-label"
                        :for="`is-active-tagsGroups-${row.item._id}`"
                      ></label>
                    </div>
                  </template>

                  <template v-slot:cell(name)="row">
                    <input
                      :id="`edit-group-name-${row.item._id}`"
                      type="text"
                      class="form-control"
                      style="display: none"
                      :value="row.item.name"
                    />
                    <span
                      :id="`group-name-${row.item._id}`"
                      style="display: block"
                    >
                      {{ row.item.name }}
                    </span>
                  </template>
                  <template v-slot:cell(action)="row">
                    <div class="text-center">
                      <button
                        :id="`group-save-${row.item._id}`"
                        class="btn btn-outline-info"
                        @click="saveTagGroup(row.item._id)"
                        style="display: none"
                      >
                        <font-awesome-icon :icon="['fas', 'save']" />
                      </button>
                      <button
                        :id="`group-pen-${row.item._id}`"
                        class="btn btn-outline-primary"
                        @click="editTagGroup(row.item._id)"
                        style="display: inline"
                      >
                        <font-awesome-icon :icon="['fas', 'pen']" />
                      </button>
                      <button
                        :id="`group-trash-${row.item._id}`"
                        class="btn btn-outline-danger"
                        @click="deleteTagGroup(row.item._id)"
                        style="display: inline"
                      >
                        <font-awesome-icon :icon="['fas', 'trash-alt']" />
                      </button>
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
          </idx-card>
        </b-tab>
        <b-tab :title="`${this.$t('menu.settings.accountData.listTags')}`">
          <idx-card :title="`${this.$t('menu.settings.accountData.listTags')}`">
            <div class="row">
              <div class="col-8">
                <div class="input-area">
                  <label for="selectedGroup">
                    {{ $t('menu.settings.accountData.tagsGroup') }}:
                  </label>
                  <b-select
                    id="selectedGroup"
                    v-model="selectedGroup"
                    :options="tagsGroupOptions"
                    @change="getTags"
                    class="col-6 form-control mb-3 ml-3"
                    :placeholder="`${this.$t(
                      'menu.settings.accountData.selectedTag',
                    )}`"
                  >
                  </b-select>
                </div>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-6">
                <div class="input-area">
                  <input
                    type="text"
                    class="form-control"
                    id="new-tag"
                    :placeholder="`${this.$t(
                      'menu.settings.accountData.newTag',
                    )}`"
                  />
                  <button class="btn btn-primary" @click="addTag">
                    <font-awesome-icon :icon="['fas', 'plus']" />
                  </button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 mt-4">
                <b-table striped :items="tags" :fields="fields">
                  <template v-slot:cell(active)="row">
                    <div class="custom-switch">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        :id="`is-active-tags-${row.item._id}`"
                        v-model="row.item.active"
                        @change="disableTag(row.item._id, row.item.active)"
                      />
                      <label
                        class="custom-control-label"
                        :for="`is-active-tags-${row.item._id}`"
                      ></label>
                    </div>
                  </template>
                  <template v-slot:cell(name)="row">
                    <input
                      :id="`edit-name-${row.item._id}`"
                      type="text"
                      class="form-control"
                      style="display: none"
                      :value="row.item.name"
                    />
                    <span :id="`name-${row.item._id}`" style="display: block">
                      {{ row.item.name }}
                    </span>
                  </template>
                  <template v-slot:cell(action)="row">
                    <div class="text-center">
                      <b-dropdown
                        size="xl"
                        variant="link"
                        toggle-class="text-decoration-none"
                        no-caret
                      >
                        <template v-slot:button-content>
                          <font-awesome-icon
                            :icon="['fas', 'plus-circle']"
                            class="text-primary"
                            style="cursor: pointer; font-size: 25px"
                            @click="getSubTags(row.item._id)"
                          />
                        </template>
                        <span style="padding: 10px">Add subtag:</span>
                        <div style="display: flex; padding: 10px">
                          <input class="input-subtag" v-model="subTag" />
                          <font-awesome-icon
                            :icon="['fas', 'plus-circle']"
                            class="text-primary"
                            style="
                              cursor: pointer;
                              font-size: 25px;
                              margin-left: 5px;
                              margin-top: 5px;
                            "
                            @click="addSubTag(row.item._id)"
                          />
                        </div>

                        <b-dropdown-text
                          v-for="(option, i) in options"
                          :key="i"
                          :id="`id-dropdown-${row.item._id}-${i}`"
                        >
                          <div class="my-1 mr-sm-2">
                            <label :for="`${row.item._id}-${i}`">
                              <input
                                :id="`edit-subtag-name-${row.item._id}-${i}`"
                                type="text"
                                class="form-control"
                                style="display: none"
                                v-model="option.name"
                              />
                              <b-form-checkbox
                                @change="activeSubTag($event, option)"
                                v-model="option.active"
                                :name="`switch-sub-tag-${i}`"
                                switch
                              >
                              </b-form-checkbox>
                              <span
                                :id="`subtag-name-${row.item._id}-${i}`"
                                style="display: block"
                              >
                                {{ option.name }}
                              </span>
                            </label>
                            <button
                              style="
                                color: red;
                                background: #ffff;
                                border: #fff;
                              "
                              @click="removeSubTag(row.item._id, option._id)"
                            >
                              x
                            </button>
                            <button
                              :id="`pen-subtag-${row.item._id}-${i}`"
                              class="btn-subtag"
                              @click="editSubTag(i, row.item._id)"
                              style="display: inline"
                            >
                              <font-awesome-icon :icon="['fas', 'pen']" />
                            </button>
                            <button
                              :id="`subtag-save-${row.item._id}-${i}`"
                              class="btn btn-outline-info"
                              style="display: none"
                              @click="
                                saveSubTag(
                                  i,
                                  option._id,
                                  option.name,
                                  row.item._id,
                                )
                              "
                            >
                              <font-awesome-icon :icon="['fas', 'save']" />
                            </button>
                          </div>
                        </b-dropdown-text>
                      </b-dropdown>
                      <button
                        :id="`save-${row.item._id}`"
                        class="btn btn-outline-info"
                        @click="saveTag(row.item._id)"
                        style="display: none"
                      >
                        <font-awesome-icon :icon="['fas', 'save']" />
                      </button>
                      <button
                        :id="`pen-${row.item._id}`"
                        class="btn btn-outline-primary"
                        @click="editTag(row.item._id)"
                        style="display: inline"
                      >
                        <font-awesome-icon :icon="['fas', 'pen']" />
                      </button>
                      <button
                        :id="`trash-${row.item._id}`"
                        class="btn btn-outline-danger"
                        @click="deleteTag(row.item._id)"
                        style="display: inline"
                      >
                        <font-awesome-icon :icon="['fas', 'trash-alt']" />
                      </button>
                      <!-- <button
                        :id="`more-${row.item._id}`"
                        class="btn btn-outline-dark"
                        style="display: inline;"
                        @click="showModal = true"
                      >
                        <font-awesome-icon :icon="['fas', 'ellipsis-h']" />
                      </button> -->

                      <b-button v-b-modal.modal-1
                      @click="($event) => setTagId(row.item._id, row.item.name)"
                      class="btn btn-light text-secondary btn-outline-secondary">
                       <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
                      </b-button>
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
          </idx-card>
        </b-tab>
      </b-tabs>
    </div>
    <b-modal id="modal-1" title="Alerta de Tag" @show="listEmail">
      <p class="my-4" style="font-family: Segoe UI, Arial, sans-serif;">
        Os emails abaixo serão notificados sempre que a tag  {{ this.tagName }} for marcada em
        uma pesquisa
      </p>
      <b>Email:</b>
      <div class="input-area">
        <input
          type="text"
          class="form-control"
          id="new-tag"
          placeholder="Digite o e-mail"
          v-model="newEmail"
          @keyup.enter="addEmail"
        />
        <button class="btn btn-primary" @click="addEmail">
          <font-awesome-icon :icon="['fas', 'plus']" />
        </button>
      </div>
      <div class="input-email" v-if="emails.length > 0">
        <div v-for="(email, index) in emails" :key="index" class="email-item">
          <span>{{ email }}</span>
          <button @click="removeEmail(email)" class="remove-btn">
            <font-awesome-icon :icon="['fas', 'times']" />
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import IdxCard from '@/components/molecules/idx-card';
import swal from 'sweetalert';
import api from '../../../services/api';

export default {
  components: { IdxCard},

  data: () => ({
    userAuth: null,
    fields: [],
    tagsGroups: [],
    tagsGroupOptions: [],
    tags: [],
    selectedGroup: null,
    subTag: null,
    options: [],
    newEmail: '',
    emails: [],
    tagId: null,
    tagName:null,
  }),

  methods: {
    async addEmail() {
      if (this.newEmail.trim() !== '') {
        this.emails.push(this.newEmail);
        this.newEmail = '';

        await api.put(
          `/email-tag/${this.tagId}`,
          {
          emails: this.emails,
          },
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          },
        );
      }
    },


  async listEmail() {
  try {
    const response = await api.get(
      `/email-tag/${this.tagId}`,
      {
        headers: {
          'x-access-token': this.userAuth.token,
        },
      },
    );
    this.emails = response.data;
  } catch (error) {
    console.log(error);
  }
},

async removeEmail(email) {
  try {
    const index = this.emails.indexOf(email); // Encontra o índice do e-mail na lista de e-mails
    await api.delete(
      `/email-tag/${this.tagId}/${email}`,
      {
        headers: {
          'x-access-token': this.userAuth.token,
        },
      },
    );
    this.emails.splice(index, 1); // Remove o e-mail da lista de e-mails
  } catch (error) {
    console.log(error);
  }
 },

    setTagId(tagId,tagName){
      this.tagId = tagId;
      this.tagName = tagName;
    },


    async activeSubTag(active, itensSubTag) {
      await api.put(
        `/update-subtags/${itensSubTag._id}`,
        {
          active,
        },
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        },
      );

      swal({
        title: 'Sucesso',
        text: 'O status da sub tag foi alterado com sucesso!',
        icon: 'success',
      });
    },

    async saveSubTag(index, idSubtag, value, tag) {
      const $input = document.getElementById(
        `edit-subtag-name-${tag}-${index}`,
      );
      $input.style.display = 'none';
      document.getElementById(`subtag-name-${tag}-${index}`).style.display =
        'block';
      document.getElementById(`subtag-save-${tag}-${index}`).style.display =
        'none';
      document.getElementById(`pen-subtag-${tag}-${index}`).style.display =
        'inline';
      document.getElementById(`id-dropdown-${tag}-${index}`).style.width =
        '300px';

      await api.put(
        `/update-subtags/${idSubtag}`,
        {
          subTagName: value,
        },
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        },
      );
    },

    editSubTag(index, tag) {
      document.getElementById(`id-dropdown-${tag}-${index}`).style.width =
        '450px';
      document.getElementById(
        `edit-subtag-name-${tag}-${index}`,
      ).style.display = 'block';
      document.getElementById(`subtag-name-${tag}-${index}`).style.display =
        'none';
      document.getElementById(`subtag-save-${tag}-${index}`).style.display =
        'inline';
      document.getElementById(`pen-subtag-${tag}-${index}`).style.display =
        'none';
    },

    async removeSubTag(mainTagId, subTagId) {
      swal({
        title: 'Falha',
        text: 'Todas as respostas vinculadas a essa subtag serão afetadas. Deseja continuar?',
        icon: 'warning',
        buttons: ['cancel', 'delete'],
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          await api.delete(`/subtags/${subTagId}`, {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          });

          this.getSubTags(mainTagId);

          swal({
            title: 'Sucesso',
            text: 'Subtag removida com sucesso!',
            icon: 'success',
          });
        }
      });
    },

    async addSubTag(mainTagId) {
      await api.post(
        '/add-subtags',
        {
          subTag: this.subTag,
          mainTagId,
        },
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        },
      );

      this.subCategory = null;

      this.getSubTags(mainTagId);
    },

    async getSubTags(mainTagId) {
      try {
        const response = await api.get(`/subtags/${mainTagId}`, {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        });

        this.options = response.data;
      } catch (error) {
        window.console.log(error);
      }
    },

    async deleteTag(id) {
      swal({
        title: 'Deletar tag',
        text: 'Todas as respostas vinculadas a essa tag serão afetadas. Deseja continuar?',
        icon: 'warning',
        buttons: ['cancelar', 'deletar'],
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          await api.delete(`/tags/${id}`, {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          });

          this.getTags();

          swal({
            title: 'Sucesso',
            text: 'Tag removida com sucesso!',
            icon: 'success',
          });
        }
      });
    },

    async saveTag(index) {
      const $input = document.getElementById(`edit-name-${index}`);
      $input.style.display = 'none';
      document.getElementById(`name-${index}`).style.display = 'block';
      document.getElementById(`save-${index}`).style.display = 'none';
      document.getElementById(`trash-${index}`).style.display = 'inline';
      document.getElementById(`pen-${index}`).style.display = 'inline';

      const newName = $input.value;
      if (newName !== '') {
        for (let i = 0; i < this.tags.length; i += 1) {
          if (this.tags[i].name === newName && this.tags[i]._id !== index) {
            swal(
              this.$t(
                'menu.settings.accountData.messages.duplicatedCategory.title',
              ),
              this.$t(
                'menu.settings.accountData.messages.duplicatedCategory.description',
              ),
              'error',
            );
            $input.value = '';
            return;
          }
        }
        try {
          await api.patch(
            `/tags/${index}`,
            {
              name: newName,
            },
            {
              headers: {
                'x-access-token': this.userAuth.token,
              },
            },
          );
          swal('Sucesso', 'Tag atualizada com sucesso', 'success');
          await this.getTags();
        } catch (error) {
          window.console.log(error);
        }
      }
    },

    editTag(index) {
      document.getElementById(`edit-name-${index}`).style.display = 'block';
      document.getElementById(`name-${index}`).style.display = 'none';
      document.getElementById(`save-${index}`).style.display = 'inline';
      document.getElementById(`trash-${index}`).style.display = 'none';
      document.getElementById(`pen-${index}`).style.display = 'none';
    },

    async disableTag(id, active) {
      try {
        await api.patch(
          `/tags/${id}`,
          { active },
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          },
        );
        swal('desabilitado com sucesso', 'success');
        await this.getTags();
      } catch (error) {
        window.console.log(error);
      }
    },

    async addTag() {
      const $input = document.getElementById('new-tag');
      const newName = $input.value;
      if (newName !== '') {
        for (let i = 0; i < this.tags.length; i += 1) {
          if (this.tags[i].name === newName) {
            swal('Error', 'Essa tag já existe!', 'error');
            return;
          }
        }
        try {
          await api.post(
            '/tags',
            {
              name: newName,
              tagGroupId: this.selectedGroup,
              isConfigTag: true,
            },
            {
              headers: {
                'x-access-token': this.userAuth.token,
              },
            },
          );
          swal('Sucesso', 'Tag criada com sucesso!', 'success');
          await this.getTags();
        } catch (error) {
          window.console.log(error);
        }
        $input.value = '';
      }
    },

    async getTags() {
      try {
        const response = await api.get('/tags', {
          headers: {
            'x-access-token': this.userAuth.token,
          },
          params: {
            tagGroup: this.selectedGroup,
            isConfigTag: true,
          },
        });
        this.tags = response.data;
      } catch (error) {
        window.console.log(error);
      }
    },

    editTagGroup(index) {
      document.getElementById(`edit-group-name-${index}`).style.display =
        'block';
      document.getElementById(`group-name-${index}`).style.display = 'none';
      document.getElementById(`group-save-${index}`).style.display = 'inline';
      document.getElementById(`group-trash-${index}`).style.display = 'none';
      document.getElementById(`group-pen-${index}`).style.display = 'none';
    },

    async saveTagGroup(index) {
      const $input = document.getElementById(`edit-group-name-${index}`);
      $input.style.display = 'none';
      document.getElementById(`group-name-${index}`).style.display = 'block';
      document.getElementById(`group-save-${index}`).style.display = 'none';
      document.getElementById(`group-trash-${index}`).style.display = 'inline';
      document.getElementById(`group-pen-${index}`).style.display = 'inline';
      const newName = $input.value;

      if (newName !== '') {
        for (let i = 0; i < this.tagsGroups.length; i += 1) {
          if (
            this.tagsGroups[i].name === newName &&
            this.tagsGroups[i]._id !== index
          ) {
            swal('Nome duplicado', 'error');
            $input.value = '';
            return;
          }
        }
        try {
          await api.patch(
            `/tag-groups/${index}`,
            {
              name: newName,
            },
            {
              headers: {
                'x-access-token': this.userAuth.token,
              },
            },
          );
          swal(
            this.$t('menu.settings.accountData.messages.updatedGroup.title'),
            'Grupo de tag atualizado com sucesso',
            'success',
          );

          await this.getTagsGroups();
        } catch (error) {
          window.console.log(error);
        }
      }
    },

    async deleteTagGroup(id) {
      try {
        await api.delete(`/tag-groups/${id}`, {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        });
        swal(
          this.$t('menu.settings.accountData.messages.deletedGroup.title'),
          'Grupo de tag removido com sucesso',
          'success',
        );
        await this.getTagsGroups();
      } catch (error) {
        window.console.log(error);
      }
    },

    async addTagsGroup() {
      const $input = document.getElementById('new-tags-group');
      const newName = $input.value;

      if (newName !== '') {
        for (let i = 0; i < this.tagsGroups.length; i += 1) {
          if (this.tagsGroups[i].name === newName) {
            swal(
              this.$t(
                'menu.settings.accountData.messages.duplicatedGroup.title',
              ),
              'Este grupo de tag já existe!',
              'error',
            );
            return;
          }
        }
        try {
          await api.post(
            '/tag-groups',
            {
              name: newName,
            },
            {
              headers: {
                'x-access-token': this.userAuth.token,
              },
            },
          );
          swal('Sucesso', 'Grupo de tag criado com sucesso!', 'success');
          await this.getTagsGroups();
        } catch (error) {
          window.console.log(error);
        }
        $input.value = '';
      }
    },

    async disableTagGroup(id, active) {
      try {
        await api.patch(
          `/tag-groups/${id}`,
          { active },
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          },
        );
        swal('Grupo desativado com sucesso', 'success');
      } catch (error) {
        window.console.log(error);
      }
    },

    async getTagsGroups() {
      try {
        const response = await api.get('/tag-groups', {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        });
        this.tagsGroups = response.data;
        this.tagsGroupOptions = [];
        for (let i = 0; i < this.tagsGroups.length; i += 1) {
          this.tagsGroupOptions.push({
            text: this.tagsGroups[i].name,
            value: this.tagsGroups[i]._id,
          });
        }
      } catch (error) {
        window.console.log(error);
      }
    },
  },

  async mounted() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    await this.getSubTags();
    await this.getTagsGroups();
  },

  created() {
    this.fields = [
      {
        key: 'active',
        label: this.$t('menu.settings.accountData.labels.active'),
        sortable: true,
      },
      {
        key: 'name',
        label: this.$t('menu.settings.accountData.labels.name'),
        sortable: true,
      },
      {
        key: 'action',
        label: this.$t('menu.settings.accountData.labels.action'),
      },
    ];
    this.groupFields = [
      {
        key: 'active',
        label: this.$t('menu.settings.accountData.labels.active'),
        sortable: true,
      },
      {
        key: 'name',
        label: this.$t('menu.settings.accountData.labels.name'),
        sortable: true,
      },
      {
        key: 'action',
        label: this.$t('menu.settings.accountData.labels.action'),
      },
    ];
  },
};
</script>

<style scoped>

.btn-outline-secondary:hover {
  background-color: #8d8d8d;
}

.btn-outline-secondary:hover .fa {
  color: #ffffff;
}


.input-email{
  display: flex;
  flex-wrap: wrap;
  width:150%;
  font-family: 'SF Pro Display', sans-serif;
}
.email-item {
  display: inline-block;
  background-color: #7ab4f2;
  color: white;
  border-radius: 4px;
  padding: 2px 12px;
  margin-right: 10px;
  margin-top: 10px;
  font-family: 'SF Pro Display';
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 24px;
  /* identical to box height, or 200% */
  align-items: center;
  text-align: center;
  color: #ffffff;
  white-space: nowrap;
  width: calc((100% - 20px)/3);
  font-family: 'SF Pro Display', sans-serif;
}

.remove-btn {
  border: none;
  background-color: transparent;
  margin-left: 1px;
  cursor: pointer;
  color: #fff;
}
label {
  display: inline-flex;
}

.b-dropdown-text {
  display: inline-block;
  padding: 0.25rem 1.5rem;
  margin-bottom: 0;
  width: 400px;
  clear: both;
  font-weight: lighter;
}

.input-area {
  display: flex;
  flex-direction: row;
}

.btn-subtag {
  border: none;
  font-size: 12px;
  color: #4ce595;
  background: #fff;
}

.input-subtag {
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  border: 1px solid #ced4da;
  border-radius: 5px;
  width: 350px;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/treatments-tags/index.vue